import { InputCCBillPurchaseDeposit } from "@scrile/api-provider/dist/api/CCBillPurchaseProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import providers from "@/lib/api";
import paymentComponent from "./CCBill.vue";
import { IntegrationModule } from "../types";

const module: IntegrationModule<InputCCBillPurchaseDeposit["billingDetails"]> = {
  paymentComponent,
  purchase: (data, billingDetails) =>
    providers.CCBillPurchaseProvider.purchaseDeposit({ data: { ...data, billingDetails } }),
  subscribe: (data, billingDetails) =>
    providers.CCBillPurchaseProvider.purchaseRecurring({
      data: {
        ...data,
        billingDetails,
      },
    }),
  allowSaveCard: true,
};

export const selector = (system: PaymentSystemPublic | null): boolean => {
  return system?.type === "ccbill" ?? false;
};

export default module;
